import React, { useState } from "react";
import LeftNav from "../../components/leftNav/LeftNav";
import TopNav from "../../components/topNav/TopNav";
import { PaymentManagement } from "../../utils/interfaces/interfaces";
import { Link } from "react-router";

const Reports: React.FC = () => {
  const fakeFacturas: PaymentManagement[] = [
    {
      id: "1001",
      customerId: "C1",
      hasProjects: false,
      customer: {
        id: "C1",
        name: "Empresa ABC",
        cedulaJuridicaProveedor: "3-101-123456",
        emailProveedor: "example@domain.com",
        accountsIban: [
          {
            id: "iban1",
            name: "Cuenta Principal",
            ibanNumber: "CR12345678901234567890",
            currency: "CRC",
          },
        ],
      },
      ibanId: "iban1",
      iban: {
        id: "iban1",
        name: "Cuenta Principal",
        ibanNumber: "CR12345678901234567890",
        currency: "CRC",
      },
      date: "2025-09-15",
      amount: 1200,
      state: "Pagada",
      responsible: {
        id: "u1",
        name: "Juan Pérez",
      },
      responsibleId: "u1",
      record: [
        {
          id: "r1",
          name: "Creación de factura",
          description: "Factura creada el 2025-09-01",
        },
      ],
      department: {
        id: "1",
        name: "Finanzas",
      },
      departmentId: "1",
      companyId: "1",
      company: {
        id: "1",
        name: "Empresa ABC",
        projects: [],
      },
      details: "Servicios de consultoría",
      bill: {
        id: "b1",
        dateBill: new Date().toISOString().split("T")[0],
        numberBill: "10001",
        dueDate: new Date().toISOString().split("T")[0],
        amount: 1200,
        state: "Pendiente",
        currency: "CRC",
      },
      billId: "b1",
      companyDepartmentId: "cd1",
      companyDepartment: {
        id: "cd1",
        name: "Departamento A",
      },
      companyDepartments: [
        {
          id: "cd1",
          name: "Departamento A",
        },
      ],
    },
    {
      id: "1002",
      customerId: "C2",
      customer: {
        id: "C2",
        name: "Servicios XYZ",
        cedulaJuridicaProveedor: "3-101-123456",
        emailProveedor: "example@domain.com",
        accountsIban: [
          {
            id: "iban2",
            name: "Cuenta Secundaria",
            ibanNumber: "US09876543210987654321",
            currency: "USD",
          },
        ],
      },
      ibanId: "iban2",
      iban: {
        id: "iban2",
        name: "Cuenta Secundaria",
        ibanNumber: "US09876543210987654321",
        currency: "USD",
      },
      date: "2025-09-15",
      amount: 2010,
      state: "Pagada",
      responsible: {
        id: "u1",
        name: "Juan Pérez",
      },
      responsibleId: "u1",
      record: [
        {
          id: "r1",
          name: "Creación de factura",
          description: "Factura creada el 2025-09-01",
        },
      ],
      department: {
        id: "2",
        name: "Compras",
      },
      departmentId: "2",
      companyId: "2",
      company: {
        id: "2",
        name: "Servicios XYZ",
        projects: [],
      },
      details: "Servicios de mantenimiento",
      bill: {
        id: "b2",
        dateBill: new Date().toISOString().split("T")[0],
        numberBill: "10002",
        dueDate: new Date().toISOString().split("T")[0],
        amount: 2010,
        state: "Pendiente",
        currency: "USD",
      },
      billId: "b2",
      companyDepartmentId: "cd1",
      hasProjects: false,
      companyDepartment: {
        id: "cd1",
        name: "Departamento B",
      },
      companyDepartments: [
        {
          id: "cd1",
          name: "Departamento B",
        },
      ],
    },
    {
      id: "1003",
      customerId: "C3",
      customer: {
        id: "C3",
        name: "Servicios XYZ",
        cedulaJuridicaProveedor: "3-101-123456",
        emailProveedor: "example@domain.com",
        accountsIban: [
          {
            id: "iban2",
            name: "Cuenta Secundaria",
            ibanNumber: "US09876543210987654321",
            currency: "USD",
          },
        ],
      },
      ibanId: "iban2",
      hasProjects: false,
      iban: {
        id: "iban2",
        name: "Cuenta Secundaria",
        ibanNumber: "US09876543210987654321",
        currency: "USD",
      },
      date: "2025-09-15",
      amount: 850,
      state: "Aprobada",
      responsible: {
        id: "u1",
        name: "Juan Pérez",
      },
      responsibleId: "u1",
      record: [
        {
          id: "r1",
          name: "Creación de factura",
          description: "Factura creada el 2025-09-01",
        },
      ],
      department: {
        id: "2",
        name: "Compras",
      },
      departmentId: "2",
      companyId: "2",
      company: {
        id: "2",
        name: "Servicios XYZ",
        projects: [],
      },
      details: "Servicios de mantenimiento",
      bill: {
        id: "b2",
        dateBill: new Date().toISOString().split("T")[0],
        numberBill: "10003",
        dueDate: new Date().toISOString().split("T")[0],
        amount: 850,
        state: "Pendiente",
        currency: "USD",
      },
      billId: "b2",
      companyDepartmentId: "cd1",
      companyDepartment: {
        id: "cd1",
        name: "Departamento B",
      },
      companyDepartments: [
        {
          id: "cd1",
          name: "Departamento B",
        },
      ],
    },
  ];

  // Agrupar facturas por empresa
  const companies = fakeFacturas.reduce((acc: any, factura) => {
    const companyId = factura.company.id;
    if (!acc[companyId]) {
      acc[companyId] = {
        company: factura.company,
        facturas: [],
        presupuesto: 0,
      };
    }
    acc[companyId].facturas.push(factura);
    return acc;
  }, {});

  const [presupuestos, setPresupuestos] = useState<{ [key: string]: number }>(
    Object.fromEntries(Object.keys(companies).map((id) => [id, 0]))
  );

  const handlePresupuestoChange = (companyId: string, value: number) => {
    setPresupuestos((prev) => ({ ...prev, [companyId]: value }));
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <LeftNav />

      <div className="flex flex-1 flex-col">
        <TopNav />

        <main className="flex-1 overflow-y-auto p-6 space-y-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">
            Reportes por Empresa
          </h1>

          {Object.values(companies).map((data: any) => {
            const totalPagos = data.facturas.reduce(
              (sum: number, f: any) => sum + f.amount,
              0
            );
            const restante = presupuestos[data.company.id] - totalPagos;

            return (
              <div
                key={data.company.id}
                className="bg-white shadow rounded-lg p-5 border border-gray-200"
              >
                <div className="flex justify-between items-center mb-3">
                  <h2 className="text-xl font-semibold text-gray-700">
                    {data.company.name}
                  </h2>

                  <div className="flex items-center gap-3">
                    <label className="text-sm text-gray-600">
                      Presupuesto:
                    </label>
                    <input
                      type="number"
                      className="border rounded px-2 py-1 text-sm w-28"
                      value={presupuestos[data.company.id] || 0}
                      onChange={(e) =>
                        handlePresupuestoChange(
                          data.company.id,
                          Number(e.target.value)
                        )
                      }
                    />
                  </div>
                </div>

                <div className="text-gray-600 mb-2">
                  <p>Total Pagos: ₡{totalPagos.toLocaleString()}</p>
                  <p>
                    Presupuesto Restante:{" "}
                    <span
                      className={
                        restante < 0
                          ? "text-red-500 font-bold"
                          : "text-green-600 font-semibold"
                      }
                    >
                      ₡{restante.toLocaleString()}
                    </span>
                  </p>
                </div>

                <table className="w-full text-sm border-t mt-3">
                  <thead className="bg-gray-50 text-gray-700">
                    <tr>
                      <th className="py-2 text-left px-2">Factura</th>
                      <th className="text-left px-2">Monto</th>
                      <th className="text-left px-2">Fecha</th>
                      <th className="text-left px-2">Estado</th>
                      <th className="text-left px-2">Ver</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.facturas.map((factura: any) => (
                      <tr
                        key={factura.id}
                        className="border-t border-gray-100 hover:bg-gray-50"
                      >
                        <td className="px-2 py-1">{factura.bill.numberBill}</td>
                        <td className="px-2 py-1">
                          ₡{factura.amount.toLocaleString()}
                        </td>
                        <td className="px-2 py-1">{factura.date}</td>
                        <td className="px-2 py-1">{factura.state}</td>
                        <Link to={`/bills/${factura.billId}`}>Ver</Link>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })}
        </main>
      </div>
    </div>
  );
};

export default Reports;
